module.exports = __webpack_public_path__ + "img/1532408147.bc852f9c.jpg";